// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

export function BillingSummarySkeleton() {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Skeleton className="h-7 w-24" />
        <Skeleton className="h-4 w-56" />
      </div>

      <Card>
        <Skeleton className="h-3 w-24 mb-2" />
        <Skeleton className="h-9 w-32" />
      </Card>

      <Card>
        <Skeleton className="h-5 w-36 mb-4" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </Card>

      <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <Card key={i}>
            <Skeleton className="h-5 w-16 mb-3" />
            <Skeleton className="h-8 w-20 mb-4" />
            <div className="space-y-2 mb-5">
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-5/6" />
              <Skeleton className="h-3 w-4/5" />
            </div>
            <Skeleton className="h-10 w-full rounded-[var(--radius)]" />
          </Card>
        ))}
      </div>
    </div>
  );
}
